import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Paper
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid } from '@mui/x-data-grid';
import {
  getAllProjects,
  createProject,
  updateProject,
  deleteProject
} from '../../controllers/project.controller';
import ProjectForm from '../../components/Projects/ProjectForm';
import { useNavigate } from 'react-router-dom';

const ProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const navigate = useNavigate();
  const fetchProjects = async () => {
    const data = await getAllProjects();
    setProjects(data);
    //console.log(data);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleSave = async (formData) => {
    if (editingProject) {
      await updateProject(editingProject._id, formData);
    } else {
      await createProject(formData);
    }
    setOpenDialog(false);
    setEditingProject(null);
    fetchProjects();
  };

  const handleDelete = async (projectId) => {
    if (window.confirm('آیا از حذف این پروژه مطمئن هستید؟')) {
      await deleteProject(projectId);
      fetchProjects();
    }
  };

  return (
    <Box sx={{ p: 3, direction: 'rtl' }}>
      <Button onClick={() => navigate('/dashboard')} variant="text" sx={{ mb: 2 }}>
        ⬅ بازگشت به داشبورد
      </Button>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        مدیریت پروژه‌ها
      </Typography>

      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => {
          setEditingProject(null);
          setOpenDialog(true);
        }}
        sx={{ mb: 2 }}
      >
        ایجاد پروژه جدید
      </Button>

      <Paper>
        <DataGrid
          rows={projects.map((p) => ({ ...p, id: p._id }))}
          columns={[
            {
              field: 'title',
              headerName: 'عنوان پروژه',
              flex: 1,
              valueGetter: (params) => {
                try {
                  return params?.fa ?? '---';
                } catch {
                  return '---';
                }
              }
            }
            ,
            { field: 'type', headerName: 'نوع', width: 100 },
            {
              field: 'actions',
              headerName: 'عملیات',
              width: 150,
              renderCell: (params) => (
                <>
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setEditingProject(params.row);
                      setOpenDialog(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(params.row._id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              )
            }
          ]}
          
          autoHeight
          disableRowSelectionOnClick
        />
      </Paper>

      {/* فرم ایجاد/ویرایش پروژه */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editingProject ? 'ویرایش پروژه' : 'ایجاد پروژه'}</DialogTitle>
        <DialogContent>
          <ProjectForm
            initialData={editingProject}
            onCancel={() => setOpenDialog(false)}
            onSubmit={handleSave}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ProjectsPage;
